// Version : 0.0.2
// Author : SHIYAM
// LastEdit : SHIYAM
// Last ADD : Added version and command lines
// MODFIED DATE : 05-09-2025

// /* eslint-disable eslint-comments/disable-enable-pair */

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

// PARTNER DETAILS ADD FUNCTION
export const partnerDetailsAdd = (partnerData: any) => {
	const data = {
		AddBusinessTokenPartner: partnerData,
	};
	const url = `${API_URL}addBusinessPartner`;
	return makeApiCall(url, data);
};

// FECH PARTNER DETAILS FUNCTION
export const fetchPartnerDetails = (fetchData: any) => {
	const data = {
		GetBusinessTokenPartner: fetchData,
	};
	const url = `${API_URL}getBusinessPartner`;
	return makeApiCall(url, data);
};

// UPDATE PARTNER DETAILS FUNCTION
export const updatePartnerDetails = (updateData: any) => {
	const data = {
		UpdatePartnerDetailsToken: updateData,
	};
	const url = `${API_URL}updateBusinessPartner`;
	return makeApiCall(url, data);
};

// DELETE PARTNER DETAILS FUNCTION
export const deletePartnerDetails = (deleteData: any) => {
	const data = {
		DeleteBusinessPartnerDetailsToken: deleteData,
	};
	const url = `${API_URL}deleteBusinessPartner`;
	return makeApiCall(url, data);
};
